import banner_a_medida from './banner_a_medida.jpg';
import fondo_login_izquierdo_sin_icono2 from "./fondo_login_izquierdo_sin_icono2.jpg";

export default {
    "banner_a_medida": banner_a_medida,
    "fondo_login_izquierdo_sin_icono2": fondo_login_izquierdo_sin_icono2
}